import React, { useState, useMemo } from 'react';

const ImageAndTextHorizontal = ({
    id,
    value: startValue,
    selectableValues,
    onChange,
    onContinue,
    isEnabled
}) => {
    const [value, setValue] = useState(startValue);

    //  Calc the longest text once
    const maxLength = useMemo(
        () => Math.max(...selectableValues.map(v => v.Caption.length)),
        [selectableValues]
    );

    // Add spaces to text - to force same sized cpq-radio-controll
    const padToMax = (text) => {
        const diff = maxLength - text.length;
        if (diff <= 0) return text;
        const left = Math.floor(diff / 2);
        const right = diff - left;

        return '\u00A0'.repeat(left) + text + '\u00A0'.repeat(right);
    };

    const handleInputChange = (event) => {
        onChange(event.target.name, event.target.value);
        setValue(event.target.value);
        onContinue();
    };

    return (
        <div className="cpq-option-input cpq-radio-control-with-image-groups" id={id}>
            {selectableValues.map((selectableValue, index) => (
                <div key={index} className="cpq-radio-control">
                    <input
                        type="radio"
                        id={selectableValue.Value + id}
                        name={id}
                        value={selectableValue.Value}
                        checked={selectableValue.Value === value}
                        onChange={handleInputChange}
                        className="cpq-radio-field"
                        disabled={!selectableValue.IsEnabled}
                    />
                    <label
                        htmlFor={selectableValue.Value + id}
                        className="cpq-radio-label"
                    ></label>

                    <label
                        htmlFor={selectableValue.Value + id}
                        className="cpq-image-label"
                    >
                        <span
                            className="cpq-radio-label-text"

                        >
                            {padToMax(selectableValue.Caption)}
                        </span>

                        {selectableValue.ImageLink ? (
                            <img
                                src={selectableValue.ImageLink}
                                alt={selectableValue.Caption}
                            />
                        ) : null}
                    </label>
                </div>
            ))}
        </div>
    );
};

export default ImageAndTextHorizontal;
